<script>
	import { createEventDispatcher } from 'svelte';

	export let value = 0;
	export let enabled = true;
	export let maxRoll = 8;

	const dispatch = createEventDispatcher();

	function changeValue(dir) {
		if (!enabled) return;
		value = dir === 'inc' ? value + 1 : value - 1;
		if (value < -maxRoll) value = -maxRoll;
		if (value > maxRoll) value = maxRoll;
		dispatch('updated', value);
	}
</script>

<div class="relative flex flex-row w-12 border border-gray-400">
	<button
		on:click|stopPropagation={() => changeValue('dec')}
		class="flex w-20 py-1 font-semibold text-white bg-gray-500 border-r border-gray-400 cursor-pointer focus:outline-none hover:bg-gray-400"
	>
		<span class="m-auto">-</span>
	</button>
	<input
		type="hidden"
		class="p-1 text-xs text-center border-gray-400 md:p-2 md:text-base focus:outline-none"
		readonly
		name="custom-input-number"
	/>
	<div class="flex items-center justify-center w-24 text-xs bg-white cursor-default">
		<span>{value || 0}</span>
	</div>

	<button
		on:click|stopPropagation={() => changeValue('inc')}
		class="flex w-20 py-1 font-semibold text-white bg-gray-500 border-l border-gray-400 cursor-pointer focus:outline-none hover:bg-gray-400"
	>
		<span class="m-auto">+</span>
	</button>
</div>
